module.exports = __webpack_public_path__ + "img/vendors.170a9e31.png";